export class Controller {

    /** @ngInject */
    constructor($state, Alert, RoleManagementResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.RoleManagementResource = RoleManagementResource;
    }

    $onInit() {
        this.model = {};
    }

    save() {
        this.isSaving = true;
        this.RoleManagementResource
            .save(this.companyId, this.appId, {loginRole: this.model, groupIds: []})
            .then((roles) => Object.assign(this.roles, roles))
            .then(() => this.$state.rolesEdited = true)
            .then(() => this.$state.go('^'))
            .then(() => this.Alert('success', 'company.manage-application.roles.add.added'))
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/add/add-role.controller.js